import { useCallback, useRef } from 'react';
import { useObserveTableElementRef } from '../../../../virtualization/hooks/useObserveTableElementRef';
import { COLUMN } from '../../../../virtualization/types/observerTypes';
import ContentComponentInner from '../../ContentComponentInner';
import { ContentComponentWithDnDLegacyPrevWrapper } from './ContentComponentWithDnDLegacyPrevWrapper';
import { useDraggingWrapperStyle } from '../../contentComponentStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export function ContentComponentWithDnDLegacyPrevInner({
  arrowsNode,
  children,
  columnIndex,
  columnName,
  columnNamespace,
  connectDragPreview,
  connectDragSource,
  connectDropTarget,
  draggedLeft,
  draggedRight,
  handleResize,
  isDragging,
  onResizeEnd,
  originalWidth,
  reorderable,
  resizable
}) {
  const initialXRef = useRef(0);
  const handleObserveRef = useObserveTableElementRef();
  const handleMouseDown = useCallback(initiatingEvent => {
    initialXRef.current = initiatingEvent.clientX;

    // Prevent the initiating event from sorting or dragging
    initiatingEvent.preventDefault();
    const handleMouseMove = ({
      clientX
    }) => handleResize(originalWidth + (clientX - initialXRef.current));
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', event => {
      // Prevent the terminating event from sorting
      event.preventDefault();
      document.removeEventListener('mousemove', handleMouseMove);
      onResizeEnd();
    }, {
      once: true
    });
  }, [handleResize, onResizeEnd, originalWidth]);
  const handleClick = useCallback(event => {
    if (resizable) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, [resizable]);
  const wrapperStyle = useDraggingWrapperStyle(isDragging);

  // connectDragSource from legacy react-dnd HOC must be applied to actual draggable element.
  // DragHandle is just visual styling, not drag functionality.
  const combinedRef = useCallback(node => {
    connectDragSource === null || connectDragSource === void 0 || connectDragSource(node);
    handleObserveRef(node);
  }, [connectDragSource, handleObserveRef]);
  const contentDiv = /*#__PURE__*/_jsx("div", Object.assign({
    ref: combinedRef,
    style: wrapperStyle,
    "data-observer-type": COLUMN,
    "data-observer-id": columnIndex
  }, reorderable && {
    'data-test-id': `drag-header-${columnNamespace}-${columnName}`
  }, {
    children: /*#__PURE__*/_jsx(ContentComponentInner, {
      arrowsNode: arrowsNode,
      columnName: columnName,
      columnNamespace: columnNamespace,
      draggedLeft: draggedLeft,
      draggedRight: draggedRight,
      isDragging: isDragging,
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      resizable: resizable,
      children: children
    })
  }));
  if (reorderable) {
    return connectDropTarget(connectDragPreview(contentDiv));
  }
  return contentDiv;
}
export const ContentComponentWithDnDLegacyPrev = ContentComponentWithDnDLegacyPrevWrapper(ContentComponentWithDnDLegacyPrevInner);